import { KText } from '@/ui-library/components';
import { Flex } from '@chakra-ui/react';
import {
  ContactItem,
  FlowItem,
  InterviewItem,
  JobItem,
  RecentSearchItem,
} from './search-items';
import {
  FlowItem as FlowItemType,
  InterviewItem as InterviewItemType,
  JobItem as JobItemType,
  ContactItem as ContactItemType,
} from './types';
import { SearchBottomBar } from './SearchBottomBar';
import { useSearchManager } from './search-manager';
import {
  useGlobalSearchHistoryTracking,
  useRecentlyViewedTracking,
} from '@/hooks';

export const RecentSearchView = () => {
  const { handleKeyDown } = useSearchManager();
  const { searchHistory } = useGlobalSearchHistoryTracking();
  const { recentlyViewed } = useRecentlyViewedTracking();
  const RECENT_ITEMS_LIMIT = 3;

  return (
    <Flex flexDirection="column" onKeyDown={(e) => handleKeyDown(e)}>
      {(recentlyViewed?.length > 0 || searchHistory?.length > 0) && (
        <Flex p="14px" flexDirection="column" overflowY="auto">
          {searchHistory?.length > 0 && (
            <>
              <KText variant="overhead" my="15px">
                Recent Searches
              </KText>
              <Flex flexDirection="column" gap="6px">
                {searchHistory
                  ?.slice(0, RECENT_ITEMS_LIMIT)
                  .map((search, index) => (
                    <RecentSearchItem key={index} text={search} />
                  ))}
              </Flex>
            </>
          )}
          {recentlyViewed?.length > 0 && (
            <>
              <KText variant="overhead" my="15px">
                Recently Viewed
              </KText>
              <Flex flexDirection="column" gap="6px">
                {recentlyViewed
                  ?.slice(0, RECENT_ITEMS_LIMIT)
                  .map((item, index) => {
                    switch (item.type) {
                      case 'flow':
                        return (
                          <FlowItem
                            key={index}
                            item={item.details as FlowItemType}
                          />
                        );
                      case 'job':
                        return (
                          <JobItem
                            key={index}
                            item={item.details as JobItemType}
                          />
                        );
                      case 'interview':
                        return (
                          <InterviewItem
                            key={index}
                            item={item.details as InterviewItemType}
                          />
                        );
                      case 'contact':
                        return (
                          <ContactItem
                            key={index}
                            item={item.details as ContactItemType}
                          />
                        );
                      default:
                        return null;
                    }
                  })}
              </Flex>
            </>
          )}
        </Flex>
      )}
      <SearchBottomBar />
    </Flex>
  );
};
